export default __webpack_public_path__ + "static/media/GeoThermalPowerGenerator.256.35723767.png";